/* @flow */
import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import Moment from 'react-moment';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';

import endpoints from 'api/endpoints';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  project: Object,
  form: TypeForm,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignCostCenterForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, actionDrawerStore, project, form }: TypeProps = this.props;

    const getChildData: Function = (child: string, val: string) => {
      return typeof project[child] === 'undefined' ? null : project[child][val];
    };

    const startDate: * = <Moment date={project.start_date} format="MMMM DD, YYYY" />;
    const endDate: * = <Moment date={project.end_date} format="MMMM DD, YYYY" />;

    const projectDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:projects.labels.code'), project.code],
      [t('general:projects.labels.name'), project.name],
      [t('general:projects.labels.start_date'), startDate],
      [t('general:projects.labels.end_date'), endDate],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.details')}
          >
            <ActionDrawerTable data={projectDetails} />
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('assignCostCenters.costCenterIds')}
            type="check"
            heading={form.$('assignCostCenters').label}
            endpoint={`${endpoints.costCenter}?search=account:${getChildData(
              'trading_account',
              'id'
            )}`}
            enableSearch={true}
            searchKeys={['code', 'name']}
            exclude={project.cost_centres.map((cc: Object) => cc.id)}
            customResponse={(resp: Object) => {
              return resp.data;
            }}
            primaryLiteral={(item: Object) => {
              return `${item.code} - ${item.name}`;
            }}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.assign_cost_centers')} />
      </React.Fragment>
    );
  }
}
